<script setup>
  import { defineAsyncComponent } from 'vue';
  import ErrorBoundary from '@/components/ErrorBoundry.vue';
  import IconBlank from '@/components/icons/IconBlank.vue';

  const props = defineProps({
    name: {
      type: String,
      required: true,
    },
  });

  const icon = defineAsyncComponent({
    loader: () => import(`../../assets/icons/icon-${props.name}.svg`),
    loadingComponent: IconBlank,
    delay: 0,
    errorComponent: IconBlank,
    timeout: 3000
  });
</script>

<template>
  <ErrorBoundary :propagate="false" v-slot="{error, attrs}">
    <component v-if="!error && icon" :is="icon" v-bind="attrs" />
    <IconBlank v-else v-bind="attrs" />
  </ErrorBoundary>
</template>